export var assign = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\"><path d=\"M9.33 0v5H0v10h9.33v5L20 10z\" id=\"Ebene_1-2\"/></svg>";